import {l} from "types/typescriptdefinisjoner_lederplan";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('OtpOppsettRessurs');

export class OtpOppsettRessurs {
    static regNavn = "OtpOppsettRessurs";

    static forInjisering() {
        return [
            "$resource",
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            OtpOppsettRessurs
        ]
    }

    private ressurs: ng.resource.IResourceClass<any>;

    constructor(private $resource: ng.resource.IResourceService,
                private ressursFeilhåndtering: RessursFeilhåndtering,
                private gettextCatalog: gettextCatalog) {
        this.ressurs = $resource<any>("/api/otpOppsett", {}, {
            initierOtpTotpOppsett: {method: "POST", url: "/api/otpOppsett/initierOtpTotpOppsett"},
            bekreftOtpTotpOppsett: {method: "POST", url: "/api/otpOppsett/bekreftOtpTotpOppsett"},
            totpReservekoder: {method: 'POST', url: '/api/otpOppsett/totpReservekoder'},
            deaktiverTotp: {method: 'POST', url: '/api/otpOppsett/deaktiverTotp'},
            aktiverSmsOtp: {method: 'POST', url: '/api/otpOppsett/aktiverSmsOtp'},
            deaktiverSmsOtp: {method: 'POST', url: '/api/otpOppsett/deaktiverSmsOtp'},
            smsOtpReservekoder: {method: 'POST', url: '/api/otpOppsett/smsOtpReservekoder'}
        });
    }


    /** Gjør loggut kall mot server med optional pushtoken som skal fjernes (ved utlogging fra ios/android) */
    initierOtpTotpOppsett(): l.InitierTotpQrkodeModell {
        debug("initierOtpTotpOppsett")
        return this.ressurs["initierOtpTotpOppsett"](
          {},
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke fornye autentiseringstoken"))
        );
    }

    /** Gjør loggut kall mot server med optional pushtoken som skal fjernes (ved utlogging fra ios/android) */
    bekreftOtpTotpOppsett(otpKode: string): l.TotpOppsettBekreftetModell {
        debug("bekreftOtpTotpOppsett", otpKode)
        return this.ressurs["bekreftOtpTotpOppsett"](
            {kode: otpKode},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke bekrefte oppsett av tofaktorautentisering"))
        );
    }

    hentTotpReservekoder(autentiseringsinfo: l.Reautentiseringsinformasjon): l.TotpReservekoderModell {
        debug("totpReservekoder");
        return this.ressurs["totpReservekoder"](
            autentiseringsinfo,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Feil under henting av reservekoder")));
    }

    deaktiverTotp(autentiseringsinfo: l.Reautentiseringsinformasjon): l.OtpDeaktivertModell {
        debug("deaktiverTotp");
        return this.ressurs["deaktiverTotp"](
            autentiseringsinfo,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Feil under deaktivering av tofaktorautentisering")));
    }

    aktiverSms(): l.SmsOtpReservekoderModell {
        return this.ressurs["aktiverSmsOtp"](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Feil under aktivering av tofaktorautentisering")));

    }

    deaktiverSms(autentiseringsinfo: l.Reautentiseringsinformasjon): l.OtpDeaktivertModell {
        return this.ressurs["deaktiverSmsOtp"](
            autentiseringsinfo,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Feil under deaktivering av tofaktorautentisering")));
    }

    hentSmsOtpReservekoder(autentiseringsinfo: l.Reautentiseringsinformasjon): l.SmsOtpReservekoderModell {
        debug("smsOtpReservekoder");
        return this.ressurs["smsOtpReservekoder"](
            autentiseringsinfo,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Feil under henting av reservekoder")));
    }

    private håndterFeil(melding: () => string){
        return this.ressursFeilhåndtering.håndterRequestFeil(melding);
    }

}
